module.exports = __webpack_public_path__ + "img/Folded_Paper_icon_design.d4fc7e18.svg";